import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DepartmentListItem from './DepartmentListItem';
import { updateEditDepartment } from '../../../actions/apiDepartmentUpdates';

const DepartmentListItemContainer = ({ department_id }) => {
  const dispatch = useDispatch();
  const edit_department = useSelector((state) => state.settings_admin.edit_department);
  const [errors, setErrors] = useState({ addDepartmentPropertyError: false });
  const [option_name, setOptionName] = useState('');

  useEffect(() => {
    if (department_id) {
      dispatch(updateEditDepartment(department_id));
    }
  }, [department_id, dispatch]);

  return (
    <div className="col-md-12">
      <div className="row bg-light pad-left-2 pad-right-2">
        {edit_department.id > 0 ? <DepartmentListItem /> : null}
      </div>
    </div>
  );
};

export default DepartmentListItemContainer;